import cn from "classnames"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { NewsItemType } from "~/api/types/NewsList"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { formatDateNew } from "~/helpers/formatDate"
import { pluralize } from "~/helpers/pluralize"

import { Picture } from "./components/Picture/Picture"
import styles from "./index.module.css"

type Props = NewsItemType & {
  className?: string
  classNameTitle?: string
  classNamePicture?: string
  slug?: string
}

export const NewsCard: React.FC<Props> = (props) => {
  const {
    name,
    video,
    youtube,
    date,
    gallery,
    code,
    className,
    classNamePicture,
    classNameTitle,
    type,
    slug,
    previewPicture,
    logo,
  } = props
  const { t } = useTranslation()
  const link = useMemo(() => {
    if (slug === "newshr") return `/press/${type}/${code}`
    return slug ? `/press/${slug}/${code}` : `/press/${type}/${code}`
  }, [slug, type, code])

  const isVideo = video || youtube

  return (
    <Card className={cn(styles.ItemWrapper, className)} link={link}>
      <Picture classNamePicture={classNamePicture} logo={logo} previewPicture={previewPicture} />

      <div className={styles.Inner}>
        <div
          className={cn(styles.Title, classNameTitle, {
            [styles.TitleWithoutPicture]: !previewPicture,
            [styles.TitleWithPicture]: previewPicture,
          })}
          dangerouslySetInnerHTML={{ __html: name }}
        />

        {!isVideo && !gallery && (
          <Heading className={styles.Date} like="h5">
            {formatDateNew(date, "d MMMM yyyy")}
          </Heading>
        )}

        {isVideo && (
          <Heading className={styles.Date} like="h5">
            <div
              className={styles.Video}
              dangerouslySetInnerHTML={{ __html: t("newsCard.Video.Title") }}
            />
          </Heading>
        )}

        {gallery && (
          <Heading className={styles.Date} like="h5">
            {gallery.length}{" "}
            {pluralize(gallery.length, [
              t("newsCard.Video.Photo.Pluralize.01"),
              t("newsCard.Video.Photo.Pluralize.02"),
              t("newsCard.Video.Photo.Pluralize.03"),
            ])}
          </Heading>
        )}
      </div>
    </Card>
  )
}
